module.exports = __webpack_public_path__ + "img/TUV.e5ecb061.gif";